import React, { useContext, useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  HStack,
  Box,
  Flex,
  Icon,
  Spinner,
} from "@chakra-ui/react";
import { FiUserCheck } from "react-icons/fi";

import { AppContext } from "AppProvider/AppContext";
import CustomInput from "components/common/customInput/CustomInput";
import { appRequest } from "routes";
import {
  departmentsOptions as staticDepartments,
  regionsOptions as staticRegions,
} from "../../common/ViewerModal/utils/constant";
import { tillomedList } from "../../common/ViewerModal/utils/constant";

interface AssignDocumentModalProps {
  isOpen: boolean;
  close: () => void;
  data: any;
  getAllData?: any;
  isPending?: any;
  isDuplicate?: any;
  updateWorflow?: any;
  level?: any;
}

const processTypeOptions = [
  { label: "PO", value: "Po" },
  { label: "Non-PO", value: "NonPo" },
];

const AssignDocumentModal: React.FC<AssignDocumentModalProps> = ({
  isOpen,
  close,
  data,
  getAllData,
  isPending,
  isDuplicate,
  updateWorflow,
  level
}) => {
  const { workflowProcess, toastNotify, accountDetails } = useContext(AppContext);
  const [sendToPending, setSendToPending] = useState<boolean>(false);
  const [value, setValue] = useState<any>(null); // for domestic, marcan, tillomed
  const [departmentValue, setDepartmentValue] = useState<any>(null); // emerging department
  const [bukrsValue, setBukrsValue] = useState<any>(null); // emerging bukrs

  const [domesticApprovers, setDomesticApprovers] = useState<any[]>([]);
  const [zuventusApprovers, setZuventusApprovers] = useState<any[]>([]);
  const [prApprovers, setPrApprovers] = useState<any[]>([]);
  const [srApprovers, setSrApprovers] = useState<any[]>([]);

  const [marcanApprovers, setMarcanApprovers] = useState<any[]>([]);
  const [dynamicDepartmentsOptions, setDynamicDepartmentsOptions] = useState<any[]>([]);
  const [dynamicRegionsOptions, setDynamicRegionsOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [processType, setProcessType] = useState<any>(processTypeOptions[1]); // ✅ ADDED

  const isDisabled = false;

  const fetchDomesticApproversFunction = async () => {
    try {
      const lists: any[] = [];
      const approvers: any = await appRequest(
        "user",
        "fetchDomesticApprovers",
        {
          ...workflowProcess,
        }
      );

      if (Array.isArray(approvers?.data)) {
        approvers.data.forEach((wf: any) => {
          wf?.approvers?.forEach((user: any) => {
            if (user?.label && user?.value) lists.push(user);
          });
        });
      }
      setDomesticApprovers(lists);
    } catch (err) {
      console.error("Error fetching domestic approvers:", err);
    }
  };

  const fetchMarcanApproversFunction = async () => {
    try {
      const response: any = await appRequest(
        "user",
        "fetchMarcanApproval2",
        workflowProcess
      );
      setMarcanApprovers(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching marcan approvers:", err);
    }
  };

  const fetchPrApproversFunction = async () => {
    try {
      const response: any = await appRequest(
        "user",
        "fetchPrApprovers",
        workflowProcess
      );
      setPrApprovers(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching pr approvers:", err);
    }
  };

  const fetchSrApproversFunction = async () => {
    try {
      const response: any = await appRequest(
        "user",
        "fetchSrApprovers",
        workflowProcess
      );
      setSrApprovers(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching sr approvers:", err);
    }
  };


  const fetchEmergingOptionsFunction = async () => {
    try {
      const response: any = await appRequest("user", "fetchEmergingOptions", {
        ...workflowProcess,
      });
      if (response?.status === "success") {
        setDynamicDepartmentsOptions(response.departments || []);
        setDynamicRegionsOptions(response.regions || []);
      }
    } catch (err) {
      console.error("Error fetching emerging options:", err);
    }
  };

  const fetchZuventusApproversFunction = async () => {
    const lists: { label: string; value: string }[] = [];
    try {
      const approvers: any = await appRequest(
        "user",
        "fetchZuventusApprovers",
        { ...workflowProcess }
      );
      if (Array.isArray(approvers?.data)) {
        approvers.data?.forEach((wf: any) => {
          if (Array.isArray(wf?.approvers)) {
            wf.approvers.forEach((user: any) => {
              if (user?.label && user?.value) {
                lists.push({ label: user.label, value: user.value });
              }
            });
          }
        });
      }
      setZuventusApprovers(lists);
    } catch (err: any) {
      console.error("Error fetching domestic approvers:", err);
    }
  };

  useEffect(() => {
    if (!isOpen) return;
    setValue(null);
    setDepartmentValue(null);
    setBukrsValue(null);
    setProcessType(processTypeOptions[1]); // reset processType

    if (workflowProcess?.processName === "domestic")
      fetchDomesticApproversFunction();
    if (workflowProcess?.processName === "zuventus")
      fetchZuventusApproversFunction();
    if (workflowProcess?.processName === "marcan")
      fetchMarcanApproversFunction();
    if (workflowProcess?.processName === "pr")
      fetchPrApproversFunction();
    if (workflowProcess?.processName === "sr")
      fetchSrApproversFunction();
    if (workflowProcess?.processName === "emerging")
      fetchEmergingOptionsFunction();
  }, [isOpen, workflowProcess?.processName]);

  const handleSubmit = async () => {
    if (loading) return;

    let finalValue = value;

    if (workflowProcess?.processName === "emerging") {

      if (!departmentValue || !bukrsValue) {
        alert("pls select the approvals")
        return;
      }

      finalValue = {
        department: departmentValue?.value,
        bukrs: bukrsValue?.value
      };
    }

    // NORMAL VALIDATION
    if (!sendToPending) {
      if (!finalValue) { alert("pls select the approvals and processType"); return };
    }

    if (isPending) {
      if (!sendToPending) {
        if (!finalValue) {
          alert("pls select the approvals and processType")
        }
      }
    }

    if (!processType) return; // must select PO / NonPO

    setLoading(true);

    try {
      const response: any = await appRequest("document", "assignDocument", {
        document: data?._id,
        workflowProcess,
        isPending: isPending,
        sendToPending: sendToPending,
        value: finalValue?.value || finalValue,
        processType: processType?.value,
        isDuplicate: isDuplicate,
        level: accountDetails?.level
      });

      if (response?.status === "success") {
        if (updateWorflow) {
          updateWorflow(finalValue)
        }
        if (getAllData) {
          getAllData(undefined, undefined, undefined, undefined, undefined);
        }
        close();
      } else {
        toastNotify({
          title: "Error",
          type: "info",
          message: response?.data,
        });
      }
    } catch (err: any) {
      console.error("Error assigning document:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={close} size="xl" isCentered>
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent
        borderRadius="2xl"
        overflow="hidden"
        bg="#f9fafb"
        boxShadow="0 10px 28px rgba(0, 0, 0, 0.18)"
      >
        <Box
          bgGradient="linear(to-r, teal.600, teal.400)"
          p={5}
          color="white"
          display="flex"
          alignItems="flex-start"
          gap={3}
        >
          <Icon as={FiUserCheck} boxSize={6} color="white" mt={1} />
          <Box flex="1">
            <ModalHeader
              m={0}
              p={0}
              fontSize="xl"
              fontWeight="bold"
              color="white"
            >
              Assign Document
            </ModalHeader>
            <Text fontSize="sm" mt={1} color="teal.50" fontWeight="normal">
              Note: Once saved, this selection cannot be changed and will update the approval workflow.
            </Text>
          </Box>
        </Box>

        <ModalCloseButton color="white" />

        <ModalBody p={6}>
          {data?.originalValues?.Vendor_Name || data?.name && <Box
            bg="white"
            p={4}
            borderRadius="lg"
            boxShadow="sm"
            border="1px solid #edf2f7"
            mb={6}
          >
            <Text fontWeight="600" fontSize="lg" color="gray.800">
              {data?.originalValues?.Vendor_Name}
            </Text>
            <Text fontSize="sm" color="gray.600">
              {data?.name}
            </Text>
          </Box>}

          <Text fontWeight="700" fontSize="md" mb={3} color="gray.700">
            Select Approver
          </Text>

          <Box
            bg="white"
            p={5}
            borderRadius="lg"
            border="1px solid #e2e8f0"
            boxShadow="xs"
          >
            <HStack spacing={4} flexWrap="wrap">
              {/* DOMESTIC */}
              {workflowProcess?.processName === "domestic" && (
                <Box flex="1" minW="260px">
                  <CustomInput
                    name="approver"
                    label="Select Initiator"
                    type="select"
                    options={domesticApprovers}
                    value={value}
                    onChange={(e: any) => setValue(e)}
                    disabled={isDisabled || loading}
                    placeholder="Select Initiator"
                    isBoxSelect
                  />
                </Box>
              )}

              {workflowProcess?.processName === "zuventus" && (
                <Box flex="1" minW="260px">
                  <CustomInput
                    name="approver"
                    label="Select Initiator"
                    type="select"
                    options={zuventusApprovers}
                    value={value}
                    onChange={(e: any) => setValue(e)}
                    disabled={isDisabled || loading}
                    placeholder="Select Initiator"
                    isBoxSelect
                  />
                </Box>
              )}

              {/* MARCAN */}
              {workflowProcess?.processName === "marcan" && (
                <Box flex="1" minW="260px">
                  <CustomInput
                    name="approver"
                    label="Select Approver Flow"
                    type="select"
                    options={marcanApprovers}
                    value={value}
                    onChange={(e: any) => setValue(e)}
                    disabled={isDisabled || loading}
                    placeholder="Select Approver"
                    isBoxSelect
                  />
                </Box>
              )}

              {/* PR */}
              {workflowProcess?.processName === "pr" && (
                <Box flex="1" minW="260px">
                  <CustomInput
                    name="approver"
                    label="Select Approver Flow"
                    type="select"
                    options={prApprovers}
                    value={value}
                    onChange={(e: any) => setValue(e)}
                    disabled={isDisabled || loading}
                    placeholder="Select Approver"
                    isBoxSelect
                  />
                </Box>
              )}

              {/* SR */}
              {workflowProcess?.processName === "sr" && (
                <Box flex="1" minW="260px">
                  <CustomInput
                    name="approver"
                    label="Select Approver Flow"
                    type="select"
                    options={srApprovers}
                    value={value}
                    onChange={(e: any) => setValue(e)}
                    disabled={isDisabled || loading}
                    placeholder="Select Approver"
                    isBoxSelect
                  />
                </Box>
              )}

              {/* EMERGING */}
              {workflowProcess?.processName === "emerging" && (
                <Flex flex="1" minW="260px" gap={4}>
                  <CustomInput
                    name="department"
                    label="Department"
                    type="select"
                    options={workflowProcess?.processName === "emerging" ? dynamicDepartmentsOptions : staticDepartments}
                    value={departmentValue}
                    onChange={(e: any) => setDepartmentValue(e)}
                    disabled={isDisabled || loading}
                    isBoxSelect
                  />
                  <CustomInput
                    name="bukrs"
                    label="Bukrs"
                    type="select"
                    options={workflowProcess?.processName === "emerging" ? dynamicRegionsOptions : staticRegions}
                    value={bukrsValue}
                    onChange={(e: any) => setBukrsValue(e)}
                    disabled={isDisabled || loading}
                    isBoxSelect
                  />
                </Flex>
              )}

              {/* TILLOMED */}
              {workflowProcess?.processName === "tillomed" && (
                <Box flex="1" minW="260px">
                  <CustomInput
                    name="approver"
                    label="Select Business & Department"
                    type="select"
                    options={tillomedList}
                    value={value}
                    onChange={(e: any) => setValue(e)}
                    disabled={isDisabled || loading}
                    isBoxSelect
                  />
                </Box>
              )}

              {/* ✅ NEW PROCESS TYPE SELECT (PO / NON-PO) */}
              <Box flex="1" minW="260px">
                <CustomInput
                  name="processType"
                  label="Process Type"
                  type="select"
                  options={processTypeOptions}
                  value={processType}
                  onChange={(e: any) => setProcessType(e)}
                  disabled={loading}
                  placeholder="Select Process Type"
                  isBoxSelect
                />
              </Box>
              {isPending && <Box mt={4}>
                <HStack>
                  <input
                    type="checkbox"
                    checked={sendToPending}
                    onChange={(e) => setSendToPending(e.target.checked)}
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <Text fontSize="sm" fontWeight="500" color="gray.700">
                    Send this document to Pending to Submit bucket
                  </Text>
                </HStack>
              </Box>}
            </HStack>
          </Box>
        </ModalBody>
        <ModalFooter
          borderTop="1px solid #e2e8f0"
          bg="#f8fafc"
          borderBottomRadius="2xl"
        >
          <Button variant="ghost" mr={3} onClick={close} disabled={loading}>
            Cancel
          </Button>
          <Button
            colorScheme="teal"
            px={6}
            onClick={handleSubmit}
            disabled={
              loading ||
              !processType ||
              (
                !sendToPending && (
                  (!value && workflowProcess?.processName !== "emerging") ||
                  (workflowProcess?.processName === "emerging" &&
                    (!departmentValue || !bukrsValue))
                )
              )
            }

          >
            {loading ? <Spinner size="sm" /> : "Assign"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AssignDocumentModal;